import { put, call, takeLatest, select } from 'redux-saga/effects';

import { get } from 'js-cookie';
import isEmpty from 'lodash/isEmpty';

import { formatError } from '../../../libs';
import productAPI from '../../api/product';
import { Types, Creators as ProductCreators } from '../../reducers/product';
import getState from '../../utils/getState';

function* sendSpecialistContact({ data }) {
  try {
    const { app } = yield select(getState);
    const siteId = app.getIn(['config', 'siteId']);

    const customer = get('customer.id') || null;
    const body = {
      site: app.getIn(['config', 'siteId']) || null,
      ...data,
      telefone: data.telefone.replace(/[^A-Z0-9]/gi, ''),
      event_id: app.getIn(['config', 'notifyMe', 'doubtProduct']),
    };

    if (customer) {
      body.customer = customer;
    }

    const result = yield call(productAPI.sendSpecialistContact, body, siteId);

    if (isEmpty(result)) {
      throw 'Ops, encontramos um problema, tente novamente.';
    }

    yield put(
      ProductCreators.sendSpecialistContactSuccess(
        'Contato enviado com sucesso. Em breve nosso consultor entrará em contato!'
      )
    );
  } catch (error) {
    yield put(ProductCreators.sendSpecialistContactError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.SEND_SPECIALIST_CONTACT_REQUEST, sendSpecialistContact);
}
